(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/player-exclusions/assets/javascripts/player-exclusions.js') >= 0) return;  svs.modules.push('/components/accountservices/player-exclusions/assets/javascripts/player-exclusions.js');

'use strict';

const {
  get: getExclusions,
  set: setExclusions,
  reset: resetExclusions
} = svs.accountservices.player_exclusions.activeExlucions;
let gamingPauseDialog;
const showPauseDialog = _ref => {
  let {
    title,
    text,
    actions,
    icon = 'self-test',
    message
  } = _ref;
  message = message || [{
    align: svs.ui.dialog.message.align.CENTER,
    text,
    type: svs.ui.dialog.message.TEXT
  }];
  gamingPauseDialog = new svs.ui.dialog.Confirm({
    actions,
    allowDimmerClick: svs.core.detect.formfactor.mobile(),
    area: svs.ui.dialog.area.POPUP,
    branding: svs.ui.dialog.branding[svs.components.lbUtils.branding],
    icon,
    message,
    title,
    type: svs.ui.dialog.type.DEFAULT
  });
  svs.ui.dialog.api.add(gamingPauseDialog);
  return gamingPauseDialog;
};
const showTTDialog = cb => {
  showPauseDialog({
    actions: [{
      title: 'OK',
      callback: () => {
        cb === null || cb === void 0 || cb();
        gamingPauseDialog.close();
      }
    }],
    text: svs.accountservices.player_exclusions.template_literals.tt_restriction(),
    title: 'Just nu kan du inte spela eller sätta in pengar',
    icon: 'help-2'
  });
};
const showDLRDialog = cb => {
  const returnUrlString = svs.utils.url.makeInternal(svs.utils.url.getLocation().pathname);
  const navigateString = "".concat(svs.core.urlMapping.get('myProfileLimits'), "?returnUrl=").concat(encodeURIComponent(returnUrlString));
  showPauseDialog({
    actions: [{
      title: 'Avbryt',
      callback: () => {
        cb === null || cb === void 0 || cb();
        gamingPauseDialog.close();
      }
    }, {
      title: 'Sätt gränser',
      callback: () => {
        cb === null || cb === void 0 || cb();
        svs.utils.url.navigate(navigateString);
      }
    }],
    text: '',
    title: 'Innan du kan börja spela behöver du sätta dina insättningsgränser',
    icon: 'help-2'
  });
};
const checkHasTTRestrictionAndShowDialog = async cb => new Promise(resolve => {
  if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER) && svs.core.detect.feature('ft-restriction-call-of-care')) {
    getExclusions(activeExclusions => {
      if (activeExclusions !== null && activeExclusions !== void 0 && activeExclusions.hasTTRestriction) {
        showTTDialog(cb);
        resolve(true);
      } else {
        resolve(false);
      }
    }, true);
  } else {
    resolve(false);
  }
});
const showGCSDialog = (gcsData, cb) => {
  showPauseDialog({
    actions: [{
      title: 'Logga ut',
      callback: () => {
        svs.utils.url.navigate("".concat(svs.core.urlMapping.get('logout'), "?returnUrl=/"));
      }
    }, {
      title: 'Okej',
      callback: () => {
        cb === null || cb === void 0 || cb();
        gamingPauseDialog.close();
      }
    }],
    text: svs.accountservices.player_exclusions.template_literals.gcs_restriction(gcsData),
    title: 'Just nu kan du inte spela eller sätta in pengar',
    icon: 'help-2'
  });
};
const checkHasRestrictionAndShowDialog = async cb => new Promise(resolve => {
  if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER) && svs.core.detect.feature('ft-restriction-call-of-care')) {
    getExclusions(activeExclusions => {
      if (activeExclusions !== null && activeExclusions !== void 0 && activeExclusions.hasTTRestriction) {
        showTTDialog(cb);
        resolve(true);
      } else if (activeExclusions !== null && activeExclusions !== void 0 && activeExclusions.hasGCSRestriction) {
        showGCSDialog(activeExclusions.gcsData, cb);
        resolve(true);
      } else {
        resolve(false);
      }
    }, true);
  } else {
    resolve(false);
  }
});
const checkHasGCSRestrictionAndShowDialog = async cb => new Promise(resolve => {
  if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER) && svs.core.detect.feature('ft-restriction-rapid-heavy-losses')) {
    getExclusions(activeExclusions => {
      if (activeExclusions !== null && activeExclusions !== void 0 && activeExclusions.hasGCSRestriction) {
        showGCSDialog(activeExclusions.gcsData, cb);
        resetExclusions();
        resolve(true);
      } else {
        resolve(false);
      }
    }, true);
  } else {
    resolve(false);
  }
});
function asyncCallback(cb) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  setTimeout(() => cb(...args), 10);
}
const getActions = function (successFn) {
  let before = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : cb => cb();
  return {
    closeButton: {
      callback: () => before(() => {
        gamingPauseDialog.close();
        successFn(false);
      }),
      title: 'STÄNG'
    }
  };
};
const handlePause = {
  narPause(callback) {
    const actions = getActions(callback);
    showPauseDialog({
      actions: [actions.closeButton],
      icon: 'spelpaus',
      text: svs.accountservices.player_exclusions.template_literals.nar_pause(true),
      title: 'Du får inte spela!'
    });
  },
  normalPause(exclusion, callback) {
    const actions = getActions(callback);
    const expiry = dateFns.format(new Date(exclusion.expiry), exclusion.is24HourExclusion ? 'dd/MM, yyyy HH:mm' : 'dd/MM, yyyy');
    showPauseDialog({
      actions: [actions.closeButton],
      icon: 'spelpaus',
      text: svs.accountservices.player_exclusions.template_literals.active_pause({
        expiry,
        isExpired: exclusion.isExpired,
        noTitle: true,
        vertical: exclusion.vertical
      }),
      title: exclusion.isExpired ? 'Spelpaus fortfarande aktiverad!' : 'Spelpaus Aktiverad!'
    });
  }
};

const canPlayOnVertical = function (vertical) {
  let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => {};
  if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
    if (!svs.accountservices.player_exclusions.utils.isValidSubSystem(vertical)) {
      vertical = 'alla';
    }
    getExclusions(activeExclusions => {
      let pause = activeExclusions[vertical];
      if (activeExclusions.isBlocked) {
        handlePause.narPause(callback);
      } else if (activeExclusions.hasTTRestriction) {
        showTTDialog();
        asyncCallback(callback, false);
      } else if (activeExclusions.hasDLRRestriction) {
        showDLRDialog();
        asyncCallback(callback, false);
      } else if (activeExclusions.hasPause && activeExclusions.hasTotalPause || pause) {
        if (!pause) {
          pause = activeExclusions.alla;
        }
        handlePause.normalPause(pause, callback);
      } else if (activeExclusions.hasGCSRestriction) {
        showGCSDialog(activeExclusions.gcsData);
        asyncCallback(callback, false);
      } else {
        asyncCallback(callback, true);
      }
    });
  } else {
    asyncCallback(callback, true);
  }
};

const hasExclusionOnVertical = function (subSystem) {
  let successFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => {};
  if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
    if (svs.core.session && svs.core.session.data && svs.core.session.data.userSession && svs.core.session.data.userSession.isBlocked) {
      successFn({
        exclusionInfo: svs.accountservices.player_exclusions.template_literals.nar_pause(),
        hasExclusions: true
      });
    } else {
      if (subSystem) {
        subSystem = subSystem.toLowerCase();
      } else {
        successFn({
          hasPause: false
        });
        return;
      }
      getExclusions(activeExclusions => {
        if (activeExclusions.hasTTRestriction) {
          successFn({
            hasExclusions: true,
            exclusionInfo: svs.accountservices.player_exclusions.template_literals.tt_restriction(),
            title: 'Just nu kan du inte spela eller sätta in pengar'
          });
          return;
        }
        let activePause;
        let useTotalPause = activeExclusions.hasTotalPause;
        const verticalPause = activeExclusions[subSystem];
        if (activeExclusions.alla && verticalPause) {
          if (dateFns.isAfter(new Date(activeExclusions.alla.expiry), new Date(verticalPause.expiry))) {
            activePause = activeExclusions.alla;
          } else {
            activePause = verticalPause;
            useTotalPause = false;
          }
        } else {
          activePause = activeExclusions.alla || verticalPause;
        }
        if (activePause) {
          let vertical = subSystem;
          if (useTotalPause) {
            vertical = 'alla spel';
          } else if (subSystem === 'sport') {
            vertical = 'sportspel';
          }
          const expiry = dateFns.format(new Date(activePause.expiry), activePause.is24HourExclusion ? 'dd/MM, yyyy HH:mm' : 'dd/MM, yyyy');
          successFn({
            exclusionInfo: svs.accountservices.player_exclusions.template_literals.active_pause({
              expiry,
              isExpired: dateFns.isAfter(new Date(), new Date(activePause.expiry)),
              vertical
            }),
            expiry: activePause.expiry,
            hasExclusions: true,
            vertical
          });
        } else {
          successFn({
            hasExclusions: false
          });
        }
      });
    }
  } else {
    successFn(false);
  }
};
svs.accountservices.player_exclusions.hasExclusionOnVertical = hasExclusionOnVertical;
svs.accountservices.player_exclusions.canPlayOnVertical = canPlayOnVertical;
svs.accountservices.player_exclusions.getActiveExlusions = getExclusions;
svs.accountservices.player_exclusions.saveExclusions = setExclusions;
svs.accountservices.player_exclusions.clearCache = resetExclusions;
svs.accountservices.player_exclusions.checkHasTTRestrictionAndShowDialog = checkHasTTRestrictionAndShowDialog;
svs.accountservices.player_exclusions.checkHasGCSRestrictionAndShowDialog = checkHasGCSRestrictionAndShowDialog;
svs.accountservices.player_exclusions.showTTDialog = showTTDialog;
svs.accountservices.player_exclusions.showGCSDialog = showGCSDialog;
svs.accountservices.player_exclusions.checkHasRestrictionAndShowDialog = checkHasRestrictionAndShowDialog;

 })(window);